// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:block}.filters{display:flex;flex-direction:column;gap:var(--uap-builder-items-padding-left-right);width:100%}.filters-items{border-top:1px solid var(--uap-loop-border-color-conditions)}.filters-actions{display:flex;gap:10px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
